<template>
    <line-chart :dataChart="chartData" :countGraph2="renderChart" :options="graphOptions"></line-chart>
</template>

<script>
    import LineChart from "../charts/LineChart"
    export default {
        components: {
            LineChart
        },
        props: {
            keywords: Array,
            project: Object,
            reset: Number
        },
        data() {
            return {
                title: "Monthly Searches",
                subtitle: "test",
                renderChart: 0,
                chartData: {
                    labels: [],
                    datasets: []
                },
                graphOptions: {
                    tooltips: {
                        callbacks: {
                            label: function (tooltipItems, data) {
                                return data.datasets[tooltipItems.datasetIndex].label + ": " + data.datasets[tooltipItems.datasetIndex].data[tooltipItems.index].toLocaleString()
                            }
                        }
                    },
                    legend: {
                        display: true,
                        labels: {
                            fontSize: 14
                        }
                    },
                    plugins: {
                        legend: {
                            labels: {
                                usePointStyle: true,
                                pointStyle: "rectRounded"
                            }
                        }
                    },
                    scales: {
                        yAxes: [
                            {
                                scaleLabel: {
                                    display: true,
                                    labelString: "Searches " + this.project.domain
                                },
                                ticks: {
                                    beginAtZero: true,
                                    callback: function (value, index, values) {
                                        return value.toLocaleString()
                                    }
                                }
                                // ticks: {
                                //     beginAtZero: true
                                // }
                            }
                        ],
                        xAxes: [
                            {
                                scaleLabel: {
                                    display: true,
                                    labelString: "Months"
                                }
                                // ticks: {
                                //     beginAtZero: true
                                // }
                            }
                        ]
                    },
                    responsive: true,
                    maintainAspectRatio: false
                }
            }
        },
        methods: {
            async fetchData() {
                try {
                    // console.log(this.selectedCompetitors)
                    // const competitorArray = this.selectedCompetitors.map((c) => c.domain)
                    // // Fetch visibility historical for selected Comps
                    const url = process.env.VUE_APP_APIURL + "/internal-searches/project/keywords/searches"
                    let post_data = {
                        company_id: localStorage.company_id,
                        project_id: this.project._id,
                        keywords: this.keywords
                    }
                    let response_data = await this.$helpers.axiosPost(url, post_data)
                    console.log(response_data)
                    this.formatChartData(
                        response_data.data.map((entry) => {
                            entry.monthly_searches = entry.data
                            return entry
                        })
                    )
                    // this.formatChartData(
                    //     response_data.data.data.sort(function (a, b) {
                    //         return b.monthly_searches[b.monthly_searches.length - 1].search_volume - a.monthly_searches[a.monthly_searches.length - 1].search_volume
                    //     })
                    // )
                    // console.log(response_data)
                } catch (error) {
                    //TODO: create notification
                    console.log(error)
                }
            },
            formatChartData(searchData) {
                // Chart-Daten-Objekt
                this.chartData = {
                    labels: [],
                    datasets: []
                }
                searchData.map((d) =>
                    d.monthly_searches.sort((a, b) => {
                        if (a.date) {
                            return a.date.localeCompare(b.date)
                        }
                        return a.importDate.localeCompare(b.importDate)
                    })
                )
                // Labels für den Chart erstellen
                this.chartData.labels = JSON.parse(JSON.stringify(searchData[0].monthly_searches)).map((entry) => entry.date || entry.importDate)

                // Daten für jeden Konkurrenten extrahieren und dem Chart-Daten-Objekt hinzufügen
                searchData.forEach((dateEntry, index) => {
                    const dataset = {
                        label: dateEntry._id || "-",
                        data: dateEntry.monthly_searches.map((entry) => entry.search_volume),
                        backgroundColor: "transparent",
                        borderColor: this.getColoFromIndex(index) || this.getColorFromString(dateEntry._id),
                        backgroundColor: (this.getColoFromIndex(index) || this.getColorFromString(dateEntry._id)) + "30",
                        pointBackgroundColor: "rgba(255, 255, 255, 1)",
                        pointStyle: "circle",
                        pointRadius: 6,
                        pointHoverRadius: 10,
                        borderWidth: 2
                        // gradient: true
                    }
                    this.chartData.datasets.push(dataset)
                })
                this.renderChart++
            },

            // Hilfsfunktion zum Generieren eines Labels
            // getDayMonthAndYear(dateString) {
            //     const date = new Date(dateString)
            //     const day = date.getDate()
            //     const month = date.toLocaleString("default", { month: "long" })
            //     const year = date.getFullYear()
            //     return `${day} ${month} ${year}`
            // },
            // Hilfsfunktion zum Generieren einer Farbe aus einer Zeichenkette
            getColoFromIndex(index) {
                let colors = ["#C2185B", "#7B1FA2", "#1976D2", "#0097A7", "#388E3C", "#AFB42B", "#F57C00", "#5D4037", "#455A64"]
                return colors[index]
            },
            getColorFromString(str) {
                let hash = 0
                for (let i = 0; i < str.length; i++) {
                    hash = str.charCodeAt(i) + ((hash << 5) - hash) + str.length
                }
                const color = Math.floor(Math.abs((Math.sin(hash) * 16777215) % 1) * 16777215).toString(16)
                return "#" + "0".repeat(6 - color.length) + color
            },
            resetChart() {
                if (this.project) {
                    this.formatChartData([{ monthly_searches: this.project.monthly_searches, _id: "Sum of all searches" }])
                }
                this.renderChart++
            }
        },
        watch: {
            reset() {
                console.log("resetChart")
                this.resetChart()
            },
            keywords() {
                console.log("keywords updated")
                this.fetchData()
            }
        },
        mounted() {
            this.resetChart()
        }
    }
</script>

<style lang="scss">
    #comp-chart-card {
        z-index: 3 !important;
    }
    #comp-chart-card > div.v-card__text {
        flex-grow: 1;
        min-height: 0;
        height: 100%;
        > div {
            position: relative;
            height: 280px;
        }
    }
</style>
